import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const CaretDown = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M11.4033 14.5943l-3.7625-3.7625c-.058-.058-.1015-.1201-.1305-.1862a.5227.5227 0 01-.0435-.2115c0-.1494.0528-.282.1585-.3978.1057-.116.2434-.174.4133-.174h7.9229c.1699 0 .3076.058.4133.174.1057.1158.1585.2484.1585.3978 0 .0413-.058.1739-.174.3977l-3.7625 3.7625c-.0913.0913-.1857.1557-.283.193a.8684.8684 0 01-.3138.056.8679.8679 0 01-.3137-.056c-.0973-.0373-.1917-.1017-.283-.193z"
    }),
    filledrtl: /*#__PURE__*/React.createElement("path", {
      d: "M11.4033 14.5943l-3.7625-3.7625c-.058-.058-.1015-.1201-.1305-.1862a.5227.5227 0 01-.0435-.2115c0-.1494.0528-.282.1585-.3978.1057-.116.2434-.174.4133-.174h7.9229c.1699 0 .3076.058.4133.174.1057.1158.1585.2484.1585.3978 0 .0413-.058.1739-.174.3977l-3.7625 3.7625c-.0913.0913-.1857.1557-.283.193a.8684.8684 0 01-.3138.056.8679.8679 0 01-.3137-.056c-.0973-.0373-.1917-.1017-.283-.193z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M11.4033 14.5943l-3.7625-3.7625c-.058-.058-.1015-.1201-.1305-.1862a.5227.5227 0 01-.0435-.2115c0-.1494.0528-.282.1585-.3978.1057-.116.2434-.174.4133-.174h7.9229c.1699 0 .3076.058.4133.174.1057.1158.1585.2484.1585.3978 0 .0413-.058.1739-.174.3977l-3.7625 3.7625c-.0913.0913-.1857.1557-.283.193a.8684.8684 0 01-.3138.056.8679.8679 0 01-.3137-.056c-.0973-.0373-.1917-.1017-.283-.193z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M11.4033 14.5943l-3.7625-3.7625c-.058-.058-.1015-.1201-.1305-.1862a.5227.5227 0 01-.0435-.2115c0-.1494.0528-.282.1585-.3978.1057-.116.2434-.174.4133-.174h7.9229c.1699 0 .3076.058.4133.174.1057.1158.1585.2484.1585.3978 0 .0413-.058.1739-.174.3977l-3.7625 3.7625c-.0913.0913-.1857.1557-.283.193a.8684.8684 0 01-.3138.056.8679.8679 0 01-.3137-.056c-.0973-.0373-.1917-.1017-.283-.193z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
CaretDown.displayName = "CaretDownIcon";

export { CaretDown, CaretDown as default };
